// Events list - https://portal.fix.ru/pages/viewpage.action?pageId=243401302

export const enum AnalyticsEvent {
  // Общие события
  AssignToMe = 'assign-to-me',
  AcceptMerchant = 'accept-merchant',
  DeclineMerchant = 'decline-merchant',
  PostponeMerchant = 'postpone-merchant',
  AcceptMarketplace = 'accept-marketplace',
  DeclineMarketplace = 'decline-marketplace',
  PostponeMarketplace = 'postpone-marketplace',
  AcceptWithoutMonitoring = 'accept-without-monitoring',
  StartScan = 'start-scan',
  PlanMonitoring = 'plan-monitoring',

  // События страницы реестра мерчантов
  Sorted = 'sorted',
  Exported = 'exported',

  // События по фильтрам
  SearchFilter = 'search-filter',
  AssignedFilter = 'assigned-filter',
  MerchantDecisionFilter = 'merchant-decision-filter',
  MerchantDecisionDateFilter = 'merchant-decision-date-filter',
  AssignedToFilter = 'assigned-to-filter',
  MarketplaceStatusFilter = 'marketplace-status-filter',
  MarketplaceStatusSubsectionFilter = 'marketplace-status-subsection-filter',
  MarketplacePriorityFilter = 'marketplace-priority-filter',
  ImportDateFilter = 'import-date-filter',
  MarketplaceStatusChangedDate = 'marketplace-status-changed-date',

  // События страницы детальной информации
  ShowAllDecisions = 'show-all-decisions',
  AvailabilityScreenshots = 'availability-screenshots',
  RknScreenshots = 'rkn-screenshots',
  ShowCurrentCollecting = 'show-current-collecting',

  // События страницы иморта
  ImportCsv = 'import-csv',
  ImportExcel = 'import-excel',
}
